import { KpiStatistic } from './kpi-statistic.js'
import { KpiStatisticQuery } from './kpi-statistic-query.js'
import { KpiStatisticMutation } from './kpi-statistic-mutation.js'

export const entities = [KpiStatistic]
export const resolvers = [KpiStatisticQuery, KpiStatisticMutation]
export const subscribers = []
